import { createStore } from 'ice';
import user from './user';
import mn from './mn';
import record from './record';

export default createStore({
  user,
  mn,
  record,
});
